import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { LineupValidationResult } from '@bm/contracts';

/** Laufende Validierungsanzeige unter dem Grid — nie nur Farbe: Icon + Text +
 * konkrete Einzelhinweise je fehlender/fehlerhafter Position (§12). */
export function LineupValidationSummary({ result }: { result: LineupValidationResult }) {
  if (result.status === 'complete') {
    return (
      <div className="flex items-center gap-2 rounded-md bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700">
        <CheckCircle2 size={16} />
        Aufstellung vollständig ({result.filledSlots}/{result.totalSlots} Positionen besetzt)
      </div>
    );
  }
  return (
    <details className="rounded-md bg-amber-50 px-3 py-1.5 text-sm text-amber-800" open={result.issues.length <= 3}>
      <summary className="flex cursor-pointer list-none items-center gap-2 font-medium">
        <AlertTriangle size={16} className="shrink-0" />
        Aufstellung noch unvollständig ({result.filledSlots}/{result.totalSlots} Positionen besetzt)
      </summary>
      {result.issues.length > 0 && (
        <ul className="mt-1 list-disc space-y-0.5 pl-6 text-amber-700">
          {result.issues.map((issue, i) => (
            <li key={i}>{issue.message}</li>
          ))}
        </ul>
      )}
    </details>
  );
}
